import { EnumSchema } from '../metadata-schema';

export const PrestatieanalyseVSOUitzondering: EnumSchema = {
	"type": "string",
	"title": "PrestatieanalyseVSOUitzondering",
	"enum": [
		"Telt mee voor prestatieanalyse",
		"Minder dan 6 weken ingeschreven"
	]
};
